import { ContainerModule } from 'inversify';

import { AureliaLoader } from './aurelia-loader';
import { AureliaLoaderConfig, IAureliaLoader, TYPES } from './aurelia-loader.types';

export const aureliaLoaderModule = new ContainerModule((bind) => {
  bind<IAureliaLoader>(TYPES.AureliaLoader).to(AureliaLoader).inSingletonScope();
});

export const createAureliaLoaderConfigModule = (config: AureliaLoaderConfig) =>
  new ContainerModule((bind) => {
    bind<AureliaLoaderConfig>(TYPES.AureliaLoaderConfig).toConstantValue(config);
  });
